export default function admin ({ next, store }) {
    return store.getters.GET_USER && !store.getters.GET_USER.role.includes('admin') ?
        store.dispatch('setAlert', { show: true, type: 'warning', message: 'You don\'t have rights to go to this page' }).then(() => {
            next({
                name: 'user.dashboard'
            })
        }) :
        next()
}
